<template>
	<div data-tour-scope="suppliers-list">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%" width="350">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->

		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.suppliers') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn v-if="!fattureincloud" elevation="0" text title="Aggiungi fornitore" data-tour="add-supplier" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<v-menu v-else bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="add-supplier" @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi fornitore</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item data-tour="add-fic" @click="getSupplierFattureincloud" v-if="fattureincloud">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Importa da Fattureincloud</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
								<!--<v-divider vertical></v-divider>
-->
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getSuppliers"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"
                            :class="{mobile: isMobile}"-->

							<!-- <template slot="headers" slot-scope="props">
                                 <tr>
                                     <th>
                                         <v-checkbox
                                                 primary
                                                 hide-details
                                                 @click.native="toggleAll"
                                                 :input-value="props.all"
                                                 :indeterminate="props.indeterminate"
                                         ></v-checkbox>
                                     </th>
                                     <th v-for="header in props.headers" :key="header.text"
                                         :class="['column sortable', settings.pagination.descending ? 'desc' : 'asc', header.value === settings.pagination.pagination.sortBy ? 'active' : '']"
                                         @click="changeSort(header.value)"
                                     >
                                         <v-icon>arrow_upward</v-icon>
                                         {{ header.text }} f
                                     </th>
                                 </tr>
                             </template>-->
							<template v-slot:body="{ items }">
								<!-- telefono: ogni fornitore diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="supplier-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.Company || 'Fornitore'" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
													<!-- <v-list-item link @click="moveItem(item)">
                                             <v-list-item-title class="size9">Sposta reference</v-list-item-title>
                                         </v-list-item>
                                         <v-list-item link @click="copyItem(item)">
                                             <v-list-item-title class="size9">Copia reference</v-list-item-title>
                                         </v-list-item>-->
												</v-list>
											</v-menu>
										</td>

										<!--<td>{{ item.id}}</td>-->

										<td>{{ item.Company }}</td>
										<td>{{ item.Email }}</td>
										<td>{{ item.Phone }}</td>
										<td>{{ item.references }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar = false"> Close </v-btn>
					</v-snackbar>
					<!--<v-btn
                            fab
                            bottom
                            right
                            color="secondary"
                            dark
                            fixed
                            @click.prevent="openNew()"
                    >

                        <v-icon>add</v-icon>
                    </v-btn>-->
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il fornitore non potrai più ripristinarlo. </v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import Vue from 'vue';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview';
import axios from 'axios';
Vue.use(VuetifyDraggableTreeview);

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createSuppliersListTourSteps, stopSuppliersListTour } from './suppliers-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';

// sotto i 4 caratteri il backend ignora la ricerca
const SEARCH_MIN = 4;
const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Supplier',
	// pagina, righe, ordinamento e ricerca stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createSuppliersListTourSteps(), { onStop: stopSuppliersListTour }),
		};
	},
	data() {
		return {
			right: true,
			permanent: false,
			miniVariant: false,
			expandOnHover: false,
			background: false,
			clippedOrder: 0,
			linkdownload: '',
			paramsUrls: '',

			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca: default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: {
					sortBy: ['id'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			listSize: LIST_SIZE,

			searchfield: '',

			total: 0,

			headers: [
				// colonna del menu a tre puntini: non si ordina (ordinava per un campo vuoto e la lista restava in caricamento)
				{ text: '', value: '', sortable: false },

				{ text: 'Fornitore', value: 'Company' },
				{ text: 'Email', value: 'Email' },
				{ text: 'Telefono', value: 'Phone' },
				{ text: 'References', value: 'references' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,

			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},

			firstLevel: [],
			secondLevel: [],
			thirdLevel: [],
			fourthLevel: [],
			listCategories: [],
			treeCategories: [],
			arrayTree: [],
			Totale: '',
			Fee: '',
			Refund: '',
			Gain: '',

			isMobile: false,

			magento: false,
			fattureincloud: false,
			langDefault: '',
			selectionType: 'leaf',
			findParant: [],
			open: [1, 2],
			menu: false,
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!value) return '';
			return value.toFixed(2);
		},
	},
	async created() {
		//this.setDialog(false)
		//this.initialize();

		this.setExistFilter(true);
		this.listLoad();
		this.linkdownload = `${this.getUrl}nocors/categories/download`;

		await this.fetchSetting();

		this.langDefault = _.find(this.getSettings.languages, { default: true }).lang;

		let fattureincloud = _.find(this.getSettings.settings, { service: 'fattureInCloud', active: true });
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
	},
	watch: {
		fab: {
			top(val) {
				this.fab.bottom = !val;
			},
			right(val) {
				this.fab.left = !val;
			},
			bottom(val) {
				this.fab.top = !val;
			},
			left(val) {
				this.fab.right = !val;
			},
		},
	},
	components: {
		TourOverlay,
		KeyValueCard,

		//VuetifyDraggableTreeview
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'categories/getIndex',
			getSuppliers: 'suppliers/getSuppliers',
			getLanguage: 'profile/getLanguage',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'categories/getSortBy',
			getSortDesc: 'categories/getSortDesc',

			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		navStateOrder: {
			get: function () {
				return this.clippedOrder;
			},
			set: function () {
				return this.clippedOrder;
			},
		},
	},
	methods: {
		// stessi dati delle colonne Email/Telefono/References della tabella desktop
		campiCard(item) {
			return [
				{ label: 'Email', value: item.Email },
				{ label: 'Telefono', value: item.Phone },
				{ label: 'References', value: item.references },
			];
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setSuppliers: 'suppliers/setSuppliers',
			setSupplier: 'suppliers/setSupplier',
			setIndex: 'suppliers/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchItems: 'suppliers/asyncFetchData',

			destroyData: 'suppliers/destroyData',
			saveData: 'users/saveData',

			setUpdateStatusCategory: 'categories/setUpdateStatusCategory',
			deleteSuppliers: 'suppliers/deleteSuppliers',
			fetchSetting: 'settings/asyncFetchData',
			updateData: 'settings/updateData',

			//'resetMessages' : 'settings/resetMessages'
		}),
		filterCheck(event) {
			this.settings.filters.categories = _.map(event, 'id');
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggleDrawerSort() {
			this.setDrawerFilter(0);
			this.clippedOrder = !this.clippedOrder;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		filterName(data) {
			return _.find(data, { lang: this.getLanguage }).text;
			//return text
		},

		changeStatus(item) {
			try {
				this.setPreload(true);
				this.isActive = true;

				this.setUpdateStatusCategory({ id: item.id, is_active: item.is_active }).then(result => {
					//this.total = result.total
					//this.items = result.data.data
					if (result.data.data.ok) {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Update successfully';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					}
					this.setPreload(false);
				});

				//console.log(response);
			} catch (err) {
				console.log(err);
			}

			//console.log(item)
		},

		async getSupplierFattureincloud() {
			try {
				this.setPreload(true);
				let url = 'fattureincloud/supplier';

				await axios.get(`${this.getUrl}${url}`, { headers: { Authorization: `Bearer ${this.getToken}` } });
				this.setPreload(false);
				this.getDataFromApi();
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione avvenuta con successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			} catch (err) {
				if (err.response) {
					let errors = err.response.data.error;
					if (errors) {
						if (_.isArray(errors)) {
							errors.forEach(value => {
								//console.log(value.msg);
								this.messages[value.param] = value.msg;
							});
						} else {
							err.message = errors;
						}
					}
					this.setPreload(false);
					this.snackbar.color = 'error';
					this.snackbar.text = err.message;
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				}
			}
		},
		// il mixin della lista riporta a pagina 1 e ricarica quando cambia la ricerca
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= SEARCH_MIN ? this.searchfield : '';
		},
		// inserimento e modifica sono pagine (si apre solo dalla riga, tre puntini):
		// la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.setClearError({});
			this.setMessages();
			this.$router.push(`/suppliers/${item._id}`);
		},
		createItem() {
			this.setClearError({});
			this.setMessages();
			this.$router.push('/suppliers/new');
		},
		// ritorna la promessa: confirmDelete aspetta il ricaricamento prima del messaggio
		getDataFromApi() {
			this.setPreload(true);
			this.isActive = true;
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result.total;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.setPreload(false);
				});
		},

		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {},

		deleteItem(item) {
			this.dialogconfirm = true;

			if (item) {
				this.form = item;
			}
		},
		confirmDelete() {
			this.dialogconfirm = false;
			// solo il fornitore scelto dai tre puntini: niente piu' eliminazione multipla
			const paypload = this.form && this.form._id ? _.filter(this.getSuppliers, { _id: this.form._id }) : [];
			this.deleteSuppliers(paypload)
				.then(() => {
					this.setPreload(false);

					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.supplier-cards,
.supplier-cards tr {
	display: block;
	width: 100%;
}
.supplier-cards tr,
.supplier-cards tr:hover {
	background: transparent !important;
}
.supplier-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.supplier-cards tr:first-child td {
	padding-top: 12px !important;
}
.supplier-cards tr:last-child td {
	padding-bottom: 12px !important;
}
</style>
